module.exports = __webpack_public_path__ + "img/chest_female_posterior.87404f85.png";